export const tagPreset = {
  tag: {
    root: {
      borderRadius: '24px',
      fontWeight: '700',
      paddingX: '0.75rem',
      paddingY: '0.25rem',
    },
    css: () => `
      .p-tag {
        border: 1px solid transparent;
        line-height: 1.2;
      }

      .p-tag.p-tag-success {
        background: #fff;
        border-color: #33B35A;
        color: #00A031;
      }

      .p-tag.p-tag-secondary {
        background: #fff;
        border-color: var(--neutral--30);
        color: var(--neutral--60);
      }

      .p-tag.p-tag-danger {
        background: #fff;
        border-color: #D45450;
        color: #C92924;
      }
    `,
  },
};
